import React, { useContext, useState } from 'react'
import { themeContext } from '../context/Theme';
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';
import { motion } from 'framer-motion';
import { BsFillSunFill, BsMoonStarsFill } from 'react-icons/bs';

const Navbar = () => {

    const [open, setOpen] = useState(false);
    const { dark, setDark, changeLang } = useContext(themeContext);

    function handleMobileMenu() {
        setOpen(!open);
    };
    function handleTheme() {
        setDark(!dark)
    };
    function handleLanguage(e) {
        const langVal = e.target.value;
        changeLang(langVal);
    };


    return (
        <nav className='fixed w-full h-10 flex justify-between items-center z-50 bg-dark_gray px-4 text-white md:px-8'>
            <p>Shubham</p>
            <div className="flex gap-4">

                <AiOutlineMenu onClick={() => {
                    handleMobileMenu();
                }} className='md:hidden text-white' />
            </div>

            {/* mobile menu */}
            <ul className={`  ${open ?
                'fixed flex gap-5 top-0 right-0 w-[50%] h-[100vh]  flex-col justify-center items-center z-50 bg-light_gray md:hidden' :
                'hidden'}  `}>


                <AiOutlineClose onClick={() => {
                    handleMobileMenu();
                }}
                    className='absolute top-2 left-2 text-3xl md:hidden text-white' />

                <select name="language" id="language"
                    defaultValue="en"
                    className='absolute mx-auto top-2 w-auto focus:outline-none md:hidden bg-dark'
                    onChange={handleLanguage}>
                    <option value="en">English</option>
                    <option value="fr">French</option>
                </select>

                <span className='absolute top-2 right-4 text-3xl md:hidden'>
                    {
                        dark ? (
                            <BsFillSunFill onClick={handleTheme} className='text-white' />
                        ) : (
                            <BsMoonStarsFill onClick={handleTheme} className='text-white' />
                        )
                    }
                </span>

                <motion.button whileHover={{ scale: 1.1 }}>
                    <a href="#Home">Home</a>
                </motion.button>
                <motion.button whileHover={{ scale: 1.1 }}>
                    <a href="#About">About</a>
                </motion.button>
                <motion.button whileHover={{ scale: 1.1 }}>
                    <a href="#Skills">Skills</a>
                </motion.button>
                <motion.button whileHover={{ scale: 1.1 }}>
                    <a href="#Portfolio">Portfolio</a>
                </motion.button>
                <motion.button whileHover={{ scale: 1.1 }}>
                    <a href="#Testimonials">Testimonials</a>
                </motion.button>
                <motion.button whileHover={{ scale: 1.1 }}>
                    <a href="#Contact">Contact</a>
                </motion.button>

            </ul>
            {/* // desktop menu */}
            <ul className=' hidden md:flex md:gap-5 md:static md:w-auto md:h-auto md:flex-row md:justify-center md:items-center' >
                <motion.button whileHover={{ scale: 1.1 }}>
                    <a href="#Home">Home</a>
                </motion.button>
                <motion.button whileHover={{ scale: 1.1 }}>
                    <a href="#About">About</a>
                </motion.button>
                <motion.button whileHover={{ scale: 1.1 }}>
                    <a href="#Skills">Skills</a>
                </motion.button>
                <motion.button whileHover={{ scale: 1.1 }}>
                    <a href="#Portfolio">Portfolio</a>
                </motion.button>
                <motion.button whileHover={{ scale: 1.1 }}>
                    <a href="#Testimonials">Testimonials</a>
                </motion.button>
                <motion.button whileHover={{ scale: 1.1 }}>
                    <a href="#Contact">Contact</a>
                </motion.button>
                <span className='hidden md:inline px-4'>
                    {
                        dark ? (
                            <BsFillSunFill onClick={handleTheme} className='text-white' />
                        ) : (
                            <BsMoonStarsFill onClick={handleTheme} className='text-white' />
                        )
                    }
                </span>
                {/* language selector dropdown */}
                <div>
                    <select name="language" id="language"
                        defaultValue="en"
                        className='w-auto focus:outline-none bg-dark_gray'
                        onChange={handleLanguage}>
                        <option value="en">English</option>
                        <option value="fr">French</option>
                    </select>
                </div>
            </ul>
        </nav>


    )
}

export default Navbar;




